import React, { useRef } from 'react'
import IconButton from '@material-ui/core/IconButton'
import ViewComfyIcon from '@material-ui/icons/ViewComfy'
import { useDisclosure } from '@plandi/common'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import clsx from 'clsx'

import { useMenuServiceButtonStyles } from './menu-service-button.styles'
import { SERVICES_URL } from './menu-service-button.constants'

const services = [
  {
    url: SERVICES_URL.main,
    title: 'Главная'
  },
  {
    url: SERVICES_URL.blog,
    title: 'Блог'
  },
  {
    url: SERVICES_URL.office,
    title: 'Офис'
  },
  {
    url: SERVICES_URL.job,
    title: 'Фриланс и Работа',
    active: true
  },
  {
    url: SERVICES_URL.shop,
    title: 'Проектный маркет'
  }
]

export const MenuServiceButton = () => {
  const classes = useMenuServiceButtonStyles()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const menuRef = useRef()

  return (
    <>
      <IconButton
        className={classes.button}
        color="inherit"
        innerRef={menuRef}
        onClick={onOpen}
      >
        <ViewComfyIcon />
      </IconButton>
      <Menu
        anchorEl={menuRef.current}
        open={isOpen}
        onClose={onClose}
        classes={{ list: classes.menu }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        {services.map((service) => {
          return (
            <MenuItem
              key={service.title}
              button
              href={service.url}
              className={clsx({
                [classes.activeLink]: service.active
              })}
              component="a"
              dense
            >
              {service.title}
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}
